var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#03CF5D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.503 2.87783V2.50115C10.503 2.22456 10.2778 2.00024 10 2.00024C9.72225 2.00024 9.497 2.22456 9.497 2.50115V2.87783H5.503V2.50115C5.503 2.22456 5.27775 2.00024 5 2.00024C4.72225 2.00024 4.497 2.22456 4.497 2.50115V2.87783H2.5V11.9793H12.5V2.87783H10.503ZM11.6395 11.0298H3.5V5.00842H11.6395V11.0298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.939 7.90753L8.2525 9.79083H9.3415V6.27222H8.20075V8.15526L6.887 6.27222H5.798V9.79083H6.939V7.90753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(2.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNaver);
export default __webpack_public_path__ + "static/media/ic-naver.f99e47a165d13a0e2d9cf20425a052b8.svg";
export { ForwardRef as ReactComponent };